import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { compose, withStateHandlers, withState, withHandlers } from 'recompose';
import cartImg from 'assets/img/white_cart.png';
import { formatPrice } from 'utils';
import { ui } from 'components';
import SizeSquare from './SizeSquare';
import ColorSquare from './ColorSquare';

import './style.scss';

const Product = ({
  id,
  name,
  code,
  img,
  material,
  description,
  density,
  price,
  saleAmount,
  count,
  increaseCount,
  reduceCount,
  addProduct,
  properties: {
    category,
    color,
    series,
    size,
  },
  chosenColor,
  setColor,
  chosenSize,
  setSize,
  validateProduct,
  isModalOpen,
  setModalOpen,
  modalMessage,
  setModalMessage,
}) => (
  <div className="product-container">
    <div className="product-container__img">
      <img src={`https://shop.yartf.ru/images/${img}.png`} alt="Фото" />
    </div>
    <div className="product-container__desc">
      <h1 className="product-container__name">{name}</h1>
      <div className="product-container__desc-block">
        <span className="product-container__desc-block__caption">Артикул: </span>
        <span>{code}</span>
      </div>
      <div className="product-container__desc-block">
        <span className="product-container__desc-block__caption">Серия: </span>
        <span>{series.map(item => item.name).join(' ,')}</span>
      </div>
      <div className="product-container__desc-block">
        <span className="product-container__desc-block__caption">Категория: </span>
        <span>{category.map(item => item.name).join(' ,')}</span>
      </div>
      {material &&
      <div className="product-container__desc-block">
        <span className="product-container__desc-block__caption">Состав: </span>
        <span>{material}</span>
      </div>}
      {density &&
      <div className="product-container__desc-block">
        <span className="product-container__desc-block__caption">Плотность: </span>
        <span>{density} г/м²</span>
      </div>}
      {description &&
        <div className="product-container__desc-block">
          <span className="product-container__desc-block__caption">Описание: </span>
          <span>{description}</span>
        </div>
      }
      <div className="product-container__price">
        <span>
          {saleAmount ? <span className="product-container__price-old">
            {formatPrice(price)}
          </span> : ''} {formatPrice(price - saleAmount)}
        </span> руб.
      </div>
      <div className="product-container__delivery-message">
        {/*<span>доставка по России бесплатно</span>*/}
        <span className="product-container__delivery-message__icon" />
      </div>
      <div className="product-container__attributes-block">
        <span>размер:</span>
        {size.map(item =>
          <SizeSquare
            key={item.id}
            name={item.name}
            active={chosenSize === item.id}
            onClick={() => setSize(item.id)}
          />)}
      </div>
      <div className="product-container__attributes-block">
        <span>цвет:</span>
        {color.map(item =>
          <ColorSquare
            key={item.id}
            color={item.rgb}
            active={chosenColor === item.id}
            onClick={() => setColor(item.id)}
          />)}
      </div>
      <div className="product-container__quantity">
        <span>количество:</span>
        <ui.Buttons.QuantityButton
          count={count}
          increaseCount={increaseCount}
          reduceCount={reduceCount}
        />
      </div>
      <ui.Buttons.BaseButton
        title="добавить в корзину"
        img={cartImg}
        onClick={() => {
          const messsage = validateProduct();

          if (messsage.length) {
            setModalMessage(messsage);
          } else {
            addProduct({
              id,
              price,
              count,
              color: chosenColor,
              size: chosenSize,
            });
            setModalMessage('Товар успешно добавлен в корзину');
          }
          setModalOpen(true);
        }}
        style={{
          width: '164px',
          marginTop: '10px',
        }}
      />
    </div>
    <Modal
      isOpen={isModalOpen}
      onAfterOpen={() => setTimeout(() => setModalOpen(false), 1500)}
      onRequestClose={() => setModalOpen(false)}
      ariaHideApp={false}
      style={{
        overlay: {
          zIndex: 1005,
          backgroundColor: 'rgba(0,0,0,0.5)',
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          padding: '40px',
          overflow: 'none',
        },
      }}
    >
      <span>{modalMessage}</span>
    </Modal>
  </div>
);

Product.propTypes = {
  id: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  description: PropTypes.string,
  material: PropTypes.string,
  density: PropTypes.number,
  price: PropTypes.number.isRequired,
  saleAmount: PropTypes.number.isRequired,

  count: PropTypes.number.isRequired,
  increaseCount: PropTypes.func.isRequired,
  reduceCount: PropTypes.func.isRequired,
  addProduct: PropTypes.func.isRequired,
  chosenColor: PropTypes.any.isRequired,
  setColor: PropTypes.func.isRequired,
  chosenSize: PropTypes.any.isRequired,
  setSize: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  setModalOpen: PropTypes.func.isRequired,
  modalMessage: PropTypes.string.isRequired,
  setModalMessage: PropTypes.func.isRequired,
  validateProduct: PropTypes.func.isRequired,

  properties: PropTypes.shape({
    category: PropTypes.array.isRequired,
    color: PropTypes.array.isRequired,
    series: PropTypes.array.isRequired,
    size: PropTypes.array.isRequired,
  }).isRequired,
};

export default compose(
  withState('isModalOpen', 'setModalOpen', false),
  withState('modalMessage', 'setModalMessage', ''),
  withState('chosenColor', 'setColor', -1),
  withState('chosenSize', 'setSize', -1),
  withStateHandlers(
    ({ count = 1 }) => ({
      count,
    }),
    {
      increaseCount: ({ count }) => () => ({
        count: count + 1,
      }),
      reduceCount: ({ count }) => () => ({
        count: count !== 1 ? count - 1 : count,
      }),
    },
  ),
  withHandlers({
    validateProduct: ({ chosenColor, chosenSize }) => () => {
      console.log(chosenColor, chosenSize);
      if (chosenColor === -1 || chosenSize === -1) {
        return 'Выберите размер и цвет!';
      }
      return '';
    },
  }),
)(Product);



// WEBPACK FOOTER //
// ./src/components/ui/Product/index.js